(function () {
  function mountOverlay() {
    var el = document.getElementById("sf-overlay");
    if (!el) return null;
    if (el.parentNode !== document.body) {
      document.body.appendChild(el);
    }
    if (!el.querySelector(".sf-backdrop")) {
      var backdrop = document.createElement("div");
      backdrop.className = "sf-backdrop";
      backdrop.setAttribute("data-sf-close", "");
      el.insertBefore(backdrop, el.firstChild);
    }
    return el;
  }

  var overlay = mountOverlay();
  var app = overlay ? overlay.querySelector("#sf-app") : null;
  if (!overlay || !app) return;
  var LANG = ((document.documentElement.lang || "").toLowerCase().indexOf("de") === 0) ? "de" : "en";

  var MEMORY_IMAGES = {
    forest: "https://images.unsplash.com/photo-1532690505755-416f854618da?q=80&w=987&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    floral_powdery: "https://images.unsplash.com/photo-1602615576820-ea14cf3e476a?q=80&w=987&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    mediterranean: "https://plus.unsplash.com/premium_photo-1664115207351-73199c7f4305?q=80&w=987&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    winter_market: "https://images.unsplash.com/photo-1544212415-8e3d2a27a944?q=80&w=2119&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    smoky_incense: "https://images.unsplash.com/photo-1608571423902-eed4a5ad8108?q=80&w=987&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    clean_linen: "https://plus.unsplash.com/premium_photo-1723652585333-a734d522e121?q=80&w=987&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    gourmand_patisserie: "https://images.unsplash.com/photo-1578985545062-69928b1d9587?q=80&w=987&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
  };

  var MEMORY_DETAILS = {
    forest: "Earthy and grounded: wet leaves and moss over vetiver, cedar, and cool mineral soil — forest-floor depth with dry woody roots.",
    floral_powdery: "Soft petals, iris, and violet over a powdery veil — elegant, romantic, and gently vintage.",
    mediterranean: "Bright and energising: sparkling citrus peel, crisp green notes, and a clean aromatic breeze — fresh without heavy sweetness.",
    winter_market: "Warm and sensual: cinnamon, cardamom, and clove over ambered woods — evening-ready spice and oriental depth.",
    smoky_incense: "Meditative and deep: wisps of smoke over frankincense, myrrh, and woody resins — atmospheric, not harsh barbecue smoke.",
    clean_linen: "Intimate and minimal: soft skin-like musk with clean cotton, soap, and a freshly showered warmth — comforting, never loud.",
    gourmand_patisserie: "Rich and comforting: melted chocolate, praline, tonka, and a soft creamy drydown — sweet, but refined, not sugary candy."
  };

  var STEPS = [
    {
      key: "occasion",
      question: "When do you reach for a fragrance?",
      multi: false,
      options: [
        { id: "daily", label: "Every day, as a quiet ritual" },
        { id: "evenings", label: "For evenings and special moments" },
        { id: "mood", label: "Whenever the mood takes me" },
        { id: "exploring", label: "I'm new to fragrance and exploring" }
      ]
    },
    {
      key: "memory",
      question: "Which memory feels closest to the scent you're drawn to?",
      multi: false,
      options: [
        { id: "forest", label: "A forest after rain", sublabel: "Vetiver, moss, cool earth" },
        { id: "floral_powdery", label: "A garden in full bloom", sublabel: "Soft petals, iris, powdery air" },
        { id: "mediterranean", label: "A Mediterranean morning", sublabel: "Bergamot, grapefruit, crisp green air" },
        { id: "winter_market", label: "A Zurich winter market", sublabel: "Cinnamon, amber, spiced woods" },
        { id: "smoky_incense", label: "Incense in a quiet room", sublabel: "Smoky embers, frankincense, dark resin" },
        { id: "clean_linen", label: "A clean linen wardrobe", sublabel: "Soft musk, clean cotton, fresh soap" },
        { id: "gourmand_patisserie", label: "A patisserie at dusk", sublabel: "Dark chocolate, caramel, warm vanilla" }
      ]
    },
    {
      key: "notes",
      question: "Which notes stand out to you most?",
      hint: "Choose at least 1 and up to 3 notes from this family.",
      multi: true,
      minSelect: 1,
      maxSelect: 3
    },
    {
      key: "intensity",
      question: "How do you wear your fragrance?",
      multi: false,
      options: [
        { id: "subtle", label: "Subtle", sublabel: "Close to skin, intimate" },
        { id: "balanced", label: "Balanced", sublabel: "Noticeable, not overwhelming" },
        { id: "bold", label: "Bold", sublabel: "A presence in the room" }
      ]
    }
  ];

  var FAMILY_NOTES = {
    forest: [
      { id: "vetiver", label: "Vetiver" },
      { id: "moss", label: "Moss" },
      { id: "cedar", label: "Cedar" },
      { id: "patchouli", label: "Patchouli" },
      { id: "pine", label: "Pine" },
      { id: "oakmoss", label: "Oakmoss" },
      { id: "sandalwood", label: "Sandalwood" },
      { id: "guaiacwood", label: "Guaiac wood" },
      { id: "earthy", label: "Earthy" },
      { id: "green", label: "Green" },
      { id: "resinous", label: "Resin" }
    ],
    floral_powdery: [
      { id: "rose", label: "Rose" },
      { id: "iris", label: "Iris" },
      { id: "violet", label: "Violet" },
      { id: "jasmine", label: "Jasmine" },
      { id: "tuberose", label: "Tuberose" },
      { id: "peony", label: "Peony" },
      { id: "magnolia", label: "Magnolia" },
      { id: "neroli", label: "Neroli" },
      { id: "orange_blossom", label: "Orange blossom" },
      { id: "heliotrope", label: "Heliotrope" },
      { id: "powdery", label: "Powdery" }
    ],
    mediterranean: [
      { id: "bergamot", label: "Bergamot" },
      { id: "lemon", label: "Lemon" },
      { id: "grapefruit", label: "Grapefruit" },
      { id: "lime", label: "Lime" },
      { id: "orange", label: "Orange" },
      { id: "mandarin", label: "Mandarin" },
      { id: "neroli", label: "Neroli" },
      { id: "petitgrain", label: "Petitgrain" },
      { id: "green", label: "Green" },
      { id: "marine", label: "Sea salt" },
      { id: "herbs", label: "Aromatic herbs" }
    ],
    winter_market: [
      { id: "cinnamon", label: "Cinnamon" },
      { id: "cardamom", label: "Cardamom" },
      { id: "clove", label: "Clove" },
      { id: "amber", label: "Amber" },
      { id: "saffron", label: "Saffron" },
      { id: "pepper", label: "Pepper" },
      { id: "pink_pepper", label: "Pink pepper" },
      { id: "cedar", label: "Cedar" },
      { id: "oriental", label: "Oriental" },
      { id: "resinous", label: "Resin" }
    ],
    smoky_incense: [
      { id: "incense", label: "Incense" },
      { id: "frankincense", label: "Frankincense" },
      { id: "myrrh", label: "Myrrh" },
      { id: "oud", label: "Oud" },
      { id: "labdanum", label: "Labdanum" },
      { id: "benzoin", label: "Benzoin" },
      { id: "tobacco", label: "Tobacco" },
      { id: "birch", label: "Birch tar" },
      { id: "smoky", label: "Smoke" },
      { id: "palo_santo", label: "Palo santo" },
      { id: "resinous", label: "Resin" }
    ],
    clean_linen: [
      { id: "musk", label: "Musk" },
      { id: "soap", label: "Soap" },
      { id: "white_linen", label: "Clean cotton" },
      { id: "fresh", label: "Fresh" },
      { id: "cotton", label: "Cotton" },
      { id: "aldehydes", label: "Aldehydes" }
    ],
    gourmand_patisserie: [
      { id: "chocolate", label: "Chocolate" },
      { id: "caramel", label: "Caramel" },
      { id: "vanilla", label: "Vanilla" },
      { id: "tonka", label: "Tonka" },
      { id: "coffee", label: "Coffee" },
      { id: "praline", label: "Praline" },
      { id: "honey", label: "Honey" },
      { id: "almond", label: "Almond" },
      { id: "chestnut", label: "Chestnut" },
      { id: "creamy", label: "Cream" },
      { id: "hazelnut", label: "Hazelnut" }
    ]
  };

  var MEMORY_TAGS = {
    forest: ["earthy", "woody", "wood", "green", "resinous", "resins", "pine", "pine_needles", "moss", "mossy", "cedar", "vetiver", "vetyver", "patchouli", "oakmoss", "sandalwood", "sandelwood", "guaiacwood"],
    floral_powdery: ["floral", "flowery", "powdery", "powedery", "rose", "iris", "orris", "orris_root", "violet", "heliotrope", "jasmine", "jasmin", "tuberose", "peony", "magnolia", "orange_blossom", "neroli"],
    mediterranean: ["citrus", "fresh", "green", "aromatic", "lemon", "bergamot", "bergamotte", "grapefruit", "lime", "orange", "mandarin", "neroli", "petitgrain", "sea_salt", "marine", "herbs"],
    winter_market: ["spicy", "spicey", "oriental", "resinous", "resins", "cinnamon", "cardamom", "cloves", "clove", "cedar", "amber", "ambergris", "saffron", "pepper", "pink_pepper"],
    smoky_incense: ["smoky", "smokey", "incense", "frankincense", "olibanum", "myrrh", "resinous", "resins", "labdanum", "benzoin", "oud", "palo_santo", "tobacco", "birch", "tar", "smoked_wood", "styrax", "opoponax", "cypriol"],
    clean_linen: ["musk", "musky", "mus", "musc", "fresh", "soap", "white_linen", "cotton", "aldehydes", "aldehyde"],
    gourmand_patisserie: ["gourmand", "chocolate", "cacao", "cocoa", "caramel", "praline", "vanilla", "tonka", "honey", "almond", "coffee", "chestnut", "creamy", "milky", "biscuit", "salted_caramel", "white_cacao", "coconut", "hazelnut"]
  };

  var PROFILES = [
    { tags: ["earthy", "woody", "smoky", "resinous"], text: "You're drawn to grounded, contemplative scents that feel like shelter: dry woods, cool resins, and earthy depth." },
    { tags: ["floral", "musky", "powdery", "fresh"], text: "You gravitate toward intimate, skin-like scents: soft florals and clean musk that feel natural and radiant." },
    { tags: ["spicy", "oriental", "gourmand", "resinous"], text: "You enjoy fragrances with character: warm spices, ambered depth, and a richer signature." },
    { tags: ["fresh", "citrus", "green", "aromatic"], text: "You prefer crisp, living scents with clean air and botanical clarity rather than heavy sweetness." }
  ];

  // Intentionally empty: recommendations must come from Shopify collection data only.
  var FALLBACK_PRODUCTS = [];

  if (LANG === "de") {
    MEMORY_DETAILS = {
      forest: "Erdig und geerdet: nasse Blätter und Moos über Vetiver, Zeder und kühl-mineralem Boden — Waldbodentiefe mit trockenen holzigen Wurzeln.",
      floral_powdery: "Weiche Blütenblätter, Iris und Veilchen mit pudrigem Schleier — elegant, romantisch und sanft vintage.",
      mediterranean: "Hell und belebend: spritzige Zitruszesten, frische grüne Noten und eine klare aromatische Brise — frisch ohne schwere Süsse.",
      winter_market: "Warm und sinnlich: Zimt, Kardamom und Nelke über amberigen Hölzern — abendtaugliche Würze und orientalische Tiefe.",
      smoky_incense: "Meditativ und tief: Rauch über Weihrauch, Myrrhe und holzigen Harzen — atmosphärisch, nicht grilliger Qualm.",
      clean_linen: "Intim und minimal: weicher, hautnaher Moschus mit reiner Baumwolle, Seife und frisch geduschter Wärme — tröstend, nie laut.",
      gourmand_patisserie: "Reich und tröstlich: geschmolzene Schokolade, Praliné, Tonka und ein weicher, cremiger Abgang — süss, aber fein, nicht bonbonhaft."
    };

    STEPS = [
      {
        key: "occasion",
        question: "Wann greifst du zu einem Parfum?",
        multi: false,
        options: [
          { id: "daily", label: "Jeden Tag, als leises Ritual" },
          { id: "evenings", label: "Für Abende und besondere Momente" },
          { id: "mood", label: "Wann immer die Stimmung mich packt" },
          { id: "exploring", label: "Ich bin neu in der Parfumwelt und entdecke" }
        ]
      },
      {
        key: "memory",
        question: "Welche Erinnerung fühlt sich dem Duft am nächsten an, den du suchst?",
        multi: false,
        options: [
          { id: "forest", label: "Ein Wald nach dem Regen", sublabel: "Vetiver, Moos, kühle Erde" },
          { id: "floral_powdery", label: "Ein Garten in voller Blüte", sublabel: "Weiche Blüten, Iris, pudrige Luft" },
          { id: "mediterranean", label: "Ein mediterraner Morgen", sublabel: "Bergamotte, Grapefruit, frische grüne Luft" },
          { id: "winter_market", label: "Ein Zürcher Weihnachtsmarkt", sublabel: "Zimt, Amber, holzige Gewürze" },
          { id: "smoky_incense", label: "Weihrauch in einem stillen Raum", sublabel: "Rauchige Glut, Weihrauch, dunkles Harz" },
          { id: "clean_linen", label: "Ein frischer Wäscheschrank", sublabel: "Weicher Moschus, reine Baumwolle, frische Seife" },
          { id: "gourmand_patisserie", label: "Eine Konditorei in der Dämmerung", sublabel: "Dunkle Schokolade, Karamell, warme Vanille" }
        ]
      },
      {
        key: "notes",
        question: "Welche Noten stechen für dich am meisten hervor?",
        hint: "Wähle mindestens 1 und höchstens 3 Noten aus dieser Duftfamilie.",
        multi: true,
        minSelect: 1,
        maxSelect: 3
      },
      {
        key: "intensity",
        question: "Wie trägst du dein Parfum?",
        multi: false,
        options: [
          { id: "subtle", label: "Dezent", sublabel: "Nah an der Haut, intim" },
          { id: "balanced", label: "Ausgewogen", sublabel: "Wahrnehmbar, nicht aufdringlich" },
          { id: "bold", label: "Markant", sublabel: "Eine Präsenz im Raum" }
        ]
      }
    ];

    PROFILES = [
      { tags: ["earthy", "woody", "smoky", "resinous"], text: "Du liebst geerdete, nachdenkliche Düfte, die wie ein Zufluchtsort wirken: trockenes Holz, kühle Harze und erdige Tiefe." },
      { tags: ["floral", "musky", "powdery", "fresh"], text: "Du neigst zu intimen, hautnahen Düften: weiche Blüten und cleaner Moschus, der natürlich und strahlend wirkt." },
      { tags: ["spicy", "oriental", "gourmand", "resinous"], text: "Du magst Düfte mit Charakter: warme Gewürze, amberige Tiefe und eine reichere Signatur." },
      { tags: ["fresh", "citrus", "green", "aromatic"], text: "Du bevorzugst frische, lebendige Düfte mit klarer Luft und botanischer Klarheit statt schwerer Süsse." }
    ];
  }

  function normalizeTag(rawTag) {
    var t = String(rawTag || "")
      .trim()
      .toLowerCase()
      .replace(/&/g, " and ")
      .replace(/[\/+]/g, " ")
      .replace(/-/g, "_")
      .replace(/\s+/g, "_");
    var synonyms = { smokey: "smoky", spicey: "spicy", powedery: "powdery", bergamotte: "bergamot", sandelwood: "sandalwood", vetyver: "vetiver", incence: "incense", frankincence: "frankincense" };
    return synonyms[t] || t;
  }

  function isProductAvailable(p) {
    if (!p || p.available == null) return true;
    var v = p.available;
    return v === true || v === "true" || v === 1;
  }

  function normalizeFragranceLevel(rawLevel) {
    function pickLevelValue(input) {
      if (input == null) return "";
      if (typeof input === "string" || typeof input === "number" || typeof input === "boolean") {
        return String(input);
      }
      if (Array.isArray(input)) {
        for (var i = 0; i < input.length; i++) {
          var arrValue = pickLevelValue(input[i]);
          if (arrValue) return arrValue;
        }
        return "";
      }
      if (typeof input === "object") {
        var keys = ["value", "label", "name", "title", "key", "handle"];
        for (var k = 0; k < keys.length; k++) {
          if (input[keys[k]] != null) {
            var objValue = pickLevelValue(input[keys[k]]);
            if (objValue) return objValue;
          }
        }
      }
      return "";
    }

    var levelRaw = pickLevelValue(rawLevel);
    var level = normalizeTag(levelRaw);
    var levelMap = {
      soft: "soft",
      subtle: "soft",
      subtile: "soft",
      light: "soft",
      mild: "soft",
      sanft: "soft",
      middle: "middle",
      medium: "middle",
      balanced: "middle",
      moderate: "middle",
      mid: "middle",
      mittel: "middle",
      intense: "intense",
      strong: "intense",
      bold: "intense",
      heavy: "intense",
      intensiv: "intense"
    };
    if (levelMap[level]) return levelMap[level];

    // Fuzzy match for composite values like "Soft / Subtle" or "Mittelstark".
    var plain = String(levelRaw || "").toLowerCase();
    if (!plain) plain = String(level || "").toLowerCase();
    if (plain.indexOf("soft") !== -1 || plain.indexOf("subtle") !== -1 || plain.indexOf("subtile") !== -1 || plain.indexOf("light") !== -1 || plain.indexOf("mild") !== -1 || plain.indexOf("sanft") !== -1) {
      return "soft";
    }
    if (plain.indexOf("middle") !== -1 || plain.indexOf("medium") !== -1 || plain.indexOf("balanced") !== -1 || plain.indexOf("moderate") !== -1 || plain.indexOf("mid") !== -1 || plain.indexOf("mittel") !== -1) {
      return "middle";
    }
    if (plain.indexOf("intense") !== -1 || plain.indexOf("strong") !== -1 || plain.indexOf("bold") !== -1 || plain.indexOf("heavy") !== -1 || plain.indexOf("intensiv") !== -1) {
      return "intense";
    }
    return "";
  }

  function targetFragranceLevel(intensity) {
    if (intensity === "subtle") return "soft";
    if (intensity === "bold") return "intense";
    return "middle";
  }

  function loadDynamicProducts() {
    var dataNode = document.getElementById("sf-products-data");
    if (!dataNode) return { hasDataNode: false, products: [] };
    var parsed;
    try {
      parsed = JSON.parse(dataNode.textContent || "[]");
    } catch (e) {
      return { hasDataNode: true, products: [] };
    }
    if (!Array.isArray(parsed)) return { hasDataNode: true, products: [] };

    var products = parsed.map(function (p) {
      var rawFragranceLevel =
        p.fragranceLevel != null ? p.fragranceLevel :
        (p.fragrance_level != null ? p.fragrance_level :
        (p.metafields && p.metafields.custom ? p.metafields.custom.fragrance_level : null));
      return {
        brand: p.brand || "",
        name: p.name || "",
        url: p.url || "#",
        image: p.image || "",
        available: isProductAvailable(p),
        tags: (Array.isArray(p.tags) ? p.tags : []).map(normalizeTag),
        fragranceLevel: normalizeFragranceLevel(rawFragranceLevel)
      };
    }).filter(function (p) {
      return p.name && p.url && p.url !== "#";
    });

    return { hasDataNode: true, products: products };
  }

  var dynamicData = loadDynamicProducts();
  var PRODUCTS = dynamicData.products;

  if (!dynamicData.hasDataNode) PRODUCTS = [];

  function getProductPool() {
    var fresh = loadDynamicProducts();
    return fresh.hasDataNode ? fresh.products : PRODUCTS;
  }

  var SAMPLE_PRODUCT_PATH = "/products/perfume-samples";

  var UI_STRINGS = {
    en: {
      notesQuestion: "Which notes stand out to you most?",
      notesHint: "Choose at least 1 and up to 3 notes from this family.",
      notesSelected: function (n, max) { return n + " of " + max + " selected"; },
      orderSamples: "Order these as samples",
      introTitle: "Find your scent",
      introDescription: "A short sensory journey to discover fragrance styles that fit your mood and personality.",
      begin: "Begin",
      resultKicker: "Your scent profile",
      resultTitle: "A curated direction for you",
      viewProduct: "View product",
      goBack: "Go back",
      startAgain: "Start again",
      noProductsLoaded: "No products loaded. In the theme editor, open the Scent Finder section and choose a Collection for recommendations, then save.",
      noProductsFound: "No products found in that collection.",
      broadenedResultsNote: "We broadened your matches slightly to show more options."
    },
    de: {
      notesQuestion: "Welche Noten stechen für dich am meisten hervor?",
      notesHint: "Wähle mindestens 1 und höchstens 3 Noten aus dieser Duftfamilie.",
      notesSelected: function (n, max) { return n + " von " + max + " gewählt"; },
      orderSamples: "Diese als Proben bestellen",
      introTitle: "Finde deinen Duft",
      introDescription: "Eine kurze sensorische Reise, um Duftstile zu entdecken, die zu deiner Stimmung und Persönlichkeit passen.",
      begin: "Starten",
      resultKicker: "Dein Duftprofil",
      resultTitle: "Eine kuratierte Richtung für dich",
      viewProduct: "Produkt ansehen",
      goBack: "Zurück",
      startAgain: "Neu starten",
      noProductsLoaded: "Keine Produkte geladen. Öffne im Theme-Editor die Scent-Finder-Sektion und wähle eine Collection für Empfehlungen, dann speichern.",
      noProductsFound: "Keine Produkte in dieser Collection gefunden.",
      broadenedResultsNote: "Wir haben die Treffer leicht erweitert, um dir mehr Optionen zu zeigen."
    }
  };

  function getSampleProductUrl() {
    var path = window.location.pathname || "";
    if (path === "/en" || path.indexOf("/en/") === 0) {
      return "/en/products/perfume-samples";
    }
    return SAMPLE_PRODUCT_PATH;
  }

  function buildSampleOrderUrl(recs) {
    if (!recs || !recs.length) return getSampleProductUrl();
    var query = recs.map(function (p) {
      return "sample=" + encodeURIComponent(p.name);
    }).join("&");
    return getSampleProductUrl() + "?" + query;
  }

  function uiLang() { return LANG; }

  function uiString(key) {
    var pack = UI_STRINGS[uiLang()] || UI_STRINGS.en;
    return pack[key];
  }

  var state = { step: -1, answers: {}, result: null };
  var sfSessionId = null;
  var lastTrackedScreen = "";

  function canTrackUser() {
    try {
      if (window.Shopify && Shopify.customerPrivacy && typeof Shopify.customerPrivacy.userCanBeTracked === "function") {
        return Shopify.customerPrivacy.userCanBeTracked();
      }
    } catch (e) {}
    return true;
  }

  function buildTrackingBase() {
    return {
      sf_session_id: sfSessionId || "unknown",
      sf_lang: uiLang(),
      sf_step_index: state.step
    };
  }

  function trackScentFinder(eventName, params) {
    if (!eventName || !canTrackUser()) return;
    var payload = Object.assign({ event: eventName }, buildTrackingBase(), params || {});

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    if (typeof window.gtag === "function") {
      var gtagPayload = Object.assign({}, payload);
      delete gtagPayload.event;
      window.gtag("event", eventName, gtagPayload);
    }
  }

  function currentAnswerSnapshot() {
    return {
      sf_occasion: (state.answers.occasion || [null])[0],
      sf_memory: (state.answers.memory || [null])[0],
      sf_intensity: (state.answers.intensity || [null])[0],
      sf_notes_count: (state.answers.notes || []).length
    };
  }

  function getSelectedMemoryId() {
    return (state.answers.memory || ["forest"])[0];
  }

  function getStepOptions(step) {
    if (!step) return [];
    if (step.key === "notes") {
      return FAMILY_NOTES[getSelectedMemoryId()] || FAMILY_NOTES.forest;
    }
    return step.options || [];
  }

  function canContinueStep(step, selected) {
    if (!step || !step.multi) return true;
    var min = step.minSelect != null ? step.minSelect : 1;
    return selected.length >= min;
  }

  function uniqTags(arr) {
    var seen = {};
    var out = [];
    (arr || []).forEach(function (t) {
      if (!t || seen[t]) return;
      seen[t] = true;
      out.push(t);
    });
    return out;
  }

  function intensityModifiers(intensity) {
    if (intensity === "subtle") {
      return {
        boost: ["musk", "musky", "powdery", "fresh", "soap", "white_linen", "iris", "orris"],
        penalise: ["smoky", "smokey", "resinous", "resins"]
      };
    }
    if (intensity === "bold") {
      return {
        boost: ["smoky", "smokey", "spicy", "spicey", "oriental", "resinous", "resins", "woody", "wood"],
        penalise: ["powdery", "powedery"]
      };
    }
    return {
      boost: ["floral", "fresh", "woody", "wood", "citrus", "musky", "musk"],
      penalise: []
    };
  }

  function occasionModifiers(occasion) {
    if (occasion === "daily") {
      return {
        boost: ["musk", "musky", "fresh", "powdery", "powedery", "citrus", "soap", "white_linen", "floral"],
        penalise: ["smoky", "smokey", "resinous"]
      };
    }
    if (occasion === "evenings") {
      return {
        boost: ["oriental", "spicy", "spicey", "vanilla", "amber", "ambergris", "resinous", "floral", "gourmand"],
        penalise: []
      };
    }
    if (occasion === "mood") {
      return {
        boost: ["floral", "woody", "wood", "citrus", "musky", "musk", "fresh"],
        penalise: []
      };
    }
    return { boost: [], penalise: [] };
  }

  function getModifiers(intensity, occasion) {
    var a = intensity ? intensityModifiers(intensity) : { boost: [], penalise: [] };
    var b = occasionModifiers(occasion);
    return {
      boost: uniqTags(a.boost.concat(b.boost)),
      penalise: uniqTags(a.penalise.concat(b.penalise))
    };
  }

  function getAllowedFragranceLevels(intensity) {
    var target = targetFragranceLevel(intensity);
    if (target === "soft") return ["soft", "middle"];
    if (target === "intense") return ["intense", "middle"];
    return ["middle"];
  }

  function scopeByFragranceLevel(scored, intensity) {
    var allowed = getAllowedFragranceLevels(intensity);
    var grouped = {};
    allowed.forEach(function (lvl) { grouped[lvl] = []; });
    grouped.unknown = [];

    (scored || []).forEach(function (s) {
      var lvl = s && s.product ? s.product.fragranceLevel : "";
      if (!lvl) {
        grouped.unknown.push(s);
        return;
      }
      if (allowed.indexOf(lvl) === -1) return;
      grouped[lvl].push(s);
    });

    var primary = allowed[0];
    var secondary = allowed[1];
    var out = grouped[primary].slice();
    if (secondary && grouped[primary].length < 3) {
      out = out.concat(grouped[secondary]);
    }
    if (out.length < 3) {
      out = out.concat(grouped.unknown);
    }
    return out;
  }

  function countNoteMatches(productTags, selectedNotes) {
    if (!selectedNotes || !selectedNotes.length) return 0;
    var selected = {};
    selectedNotes.forEach(function (t) { selected[t] = true; });
    var matches = 0;
    (productTags || []).forEach(function (t) {
      if (selected[t]) matches += 1;
    });
    return matches;
  }

  function tagOverlapCount(tagsA, tagsB) {
    var inB = {};
    var overlap = 0;
    (tagsB || []).forEach(function (t) { inB[t] = true; });
    (tagsA || []).forEach(function (t) {
      if (inB[t]) overlap += 1;
    });
    return overlap;
  }

  function brandKey(product) {
    return normalizeTag(product.brand || product.name || "");
  }

  function shuffleScoreBand(items) {
    var i = 0;
    while (i < items.length) {
      var bandScore = items[i].score;
      var j = i + 1;
      while (j < items.length && items[j].score === bandScore) j += 1;
      if (j - i > 1) {
        var band = items.slice(i, j);
        band.sort(function () { return Math.random() - 0.5; });
        for (var k = 0; k < band.length; k++) items[i + k] = band[k];
      }
      i = j;
    }
  }

  function pickDiverseRecommendations(scored, limit, fallbackScored) {
    limit = limit || 3;
    var usedFallback = false;
    var candidates = scored.filter(function (s) { return s.score > 0 && s.product && s.product.name; });
    if (!candidates.length) {
      candidates = scored.filter(function (s) { return s.product && s.product.name; });
    }
    if (!candidates.length && fallbackScored && fallbackScored.length) {
      candidates = fallbackScored.filter(function (s) { return s.score > 0 && s.product && s.product.name; });
      if (!candidates.length) {
        candidates = fallbackScored.filter(function (s) { return s.product && s.product.name; });
      }
      if (candidates.length) usedFallback = true;
    }
    if (!candidates.length) {
      return {
        products: [],
        usedFallback: false
      };
    }

    shuffleScoreBand(candidates);

    var picked = [];
    var pickedKeys = {};
    var usedBrands = {};
    var working = candidates.map(function (s) {
      return { product: s.product, score: s.score, noteMatches: s.noteMatches, used: false };
    });
    function productKey(product) {
      return (product && (product.url || product.name || "")) + "";
    }

    while (picked.length < limit) {
      var requireDifferentBrand = picked.length > 0;
      var bestIdx = -1;
      var bestEffective = -Infinity;

      for (var i = 0; i < working.length; i++) {
        if (working[i].used) continue;
        var item = working[i];
        var bk = brandKey(item.product);

        if (requireDifferentBrand && usedBrands[bk]) continue;

        var diversityPenalty = 0;
        for (var p = 0; p < picked.length; p++) {
          diversityPenalty += tagOverlapCount(item.product.tags, picked[p].tags) * 3;
          if (brandKey(picked[p]) === bk) diversityPenalty += 2;
        }

        var effective = item.score - diversityPenalty;
        if (effective > bestEffective) {
          bestEffective = effective;
          bestIdx = i;
        }
      }

      if (bestIdx < 0) {
        for (var f = 0; f < working.length; f++) {
          if (!working[f].used) {
            bestIdx = f;
            break;
          }
        }
      }

      if (bestIdx < 0) break;

      working[bestIdx].used = true;
      usedBrands[brandKey(working[bestIdx].product)] = true;
      picked.push(working[bestIdx].product);
      pickedKeys[productKey(working[bestIdx].product)] = true;
    }

    // Tier 3 safety: if strict/diverse picks are too few, backfill
    // with highest-ranked remaining perfumes from the broader pool.
    if (picked.length < limit) {
      var fallback = (fallbackScored && fallbackScored.length) ? fallbackScored : scored;
      for (var r = 0; r < fallback.length && picked.length < limit; r++) {
        var fp = fallback[r] && fallback[r].product;
        if (!fp) continue;
        var fKey = productKey(fp);
        if (pickedKeys[fKey]) continue;
        picked.push(fp);
        pickedKeys[fKey] = true;
        usedFallback = true;
      }
    }

    return {
      products: picked,
      usedFallback: usedFallback
    };
  }

  function computeResult(answers) {
    var pool = getProductPool();
    var selectedNotes = uniqTags(answers.notes || []);
    var hasSelectedNotes = selectedNotes.length > 0;
    var memoryId = answers.memory || "forest";

    var tagCounts = {};
    function addTag(tag, weight) { tagCounts[tag] = (tagCounts[tag] || 0) + (weight || 1); }

    if (hasSelectedNotes) {
      selectedNotes.forEach(function (t) { addTag(t, 6); });
      var selectedSet = {};
      selectedNotes.forEach(function (t) { selectedSet[t] = true; });
      (MEMORY_TAGS[memoryId] || []).forEach(function (t) {
        if (!selectedSet[t]) addTag(t, 1);
      });
    } else {
      (MEMORY_TAGS[memoryId] || []).forEach(function (t) { addTag(t, 3); });
    }

    // Intensity selection is handled only via fragrance-level metafield matching.
    var mod = getModifiers(null, answers.occasion);
    var modifierWeight = hasSelectedNotes ? 1 : 2;
    mod.boost.forEach(function (t) { addTag(t, modifierWeight); });
    mod.penalise.forEach(function (t) { tagCounts[t] = (tagCounts[t] || 0) - 1; });

    if (!pool.length) {
      return { profile: PROFILES[0].text, dominantTags: [], recs: [], noCollection: true };
    }

    var scored = pool.map(function (p) {
      var score = 0;
      p.tags.forEach(function (t) { score += tagCounts[t] || 0; });
      return {
        product: p,
        score: score,
        noteMatches: countNoteMatches(p.tags, selectedNotes)
      };
    });

    scored.sort(function (a, b) {
      var ai = a.product.available ? 1 : 0;
      var bi = b.product.available ? 1 : 0;
      if (bi !== ai) return bi - ai;
      if (b.score !== a.score) return b.score - a.score;
      if (b.noteMatches !== a.noteMatches) return b.noteMatches - a.noteMatches;
      return Math.random() - 0.5;
    });
    scored = scopeByFragranceLevel(scored, answers.intensity);
    var fallbackScored = scored.slice();
    if (hasSelectedNotes) {
      scored = scored.filter(function (s) { return s.noteMatches > 0; });
    }

    var dominantTags = hasSelectedNotes
      ? selectedNotes.slice(0, 4)
      : Object.keys(tagCounts).sort(function (a, b) { return (tagCounts[b] || 0) - (tagCounts[a] || 0); }).slice(0, 4);

    var profile = PROFILES[0].text;
    var bestOverlap = -1;
    PROFILES.forEach(function (p) {
      var overlap = p.tags.filter(function (t) { return dominantTags.indexOf(t) !== -1; }).length;
      if (overlap > bestOverlap) {
        bestOverlap = overlap;
        profile = p.text;
      }
    });

    var recommendationPack = pickDiverseRecommendations(scored, 3, fallbackScored);

    return {
      profile: profile,
      dominantTags: dominantTags,
      recs: recommendationPack.products,
      fallbackUsed: recommendationPack.usedFallback,
      noCollection: false
    };
  }

  function esc(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function openOverlay() {
    overlay.classList.add("is-open");
    overlay.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    sfSessionId = "sf_" + Date.now() + "_" + Math.floor(Math.random() * 1000000);
    lastTrackedScreen = "";
    trackScentFinder("scent_finder_open");
    render();
  }

  function closeOverlay() {
    trackScentFinder("scent_finder_close", currentAnswerSnapshot());
    overlay.classList.remove("is-open");
    overlay.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  function render() {
    if (state.result) {
      var resultScreenKey = "result:" + ((state.result.recs && state.result.recs.length) || 0);
      if (lastTrackedScreen !== resultScreenKey) {
        lastTrackedScreen = resultScreenKey;
        trackScentFinder("scent_finder_result_view", Object.assign({}, currentAnswerSnapshot(), {
          sf_result_count: (state.result.recs || []).length,
          sf_fallback_used: !!state.result.fallbackUsed,
          sf_no_collection: !!state.result.noCollection,
          sf_result_names: (state.result.recs || []).map(function (p) { return p.name; }).join(",")
        }));
      }
      var hasRecs = state.result.recs.length > 0;
      var sampleOrderUrl = buildSampleOrderUrl(state.result.recs);
      var items = state.result.recs.map(function (p) {
        return ''
          + '<li class="sf-result-item">'
          + (p.image ? '<img class="sf-result-image" src="' + esc(p.image) + '" alt="' + esc(p.name) + '">' : '<div class="sf-result-image sf-result-image-placeholder"></div>')
          + '<div class="sf-result-meta"><strong>' + esc(p.brand) + '</strong><span>' + esc(p.name) + '</span></div>'
          + '<a href="' + esc(p.url) + '">' + esc(uiString("viewProduct")) + '</a>'
          + '</li>';
      }).join("");
      var emptyState = "";
      if (!hasRecs) {
        if (state.result.noCollection) {
          emptyState = '<p class="sf-profile">' + esc(uiString("noProductsLoaded")) + "</p>";
        } else {
          emptyState = '<p class="sf-profile">' + esc(uiString("noProductsFound")) + "</p>";
        }
      }
      var broadenedState = (hasRecs && state.result.fallbackUsed)
        ? '<p class="sf-meta sf-meta-count">' + esc(uiString("broadenedResultsNote")) + "</p>"
        : "";
      var sampleBtn = hasRecs
        ? '<a class="sf-btn sf-btn-primary sf-btn-samples" href="' + esc(sampleOrderUrl) + '">' + esc(uiString("orderSamples")) + "</a>"
        : "";
      app.innerHTML = ''
        + '<div class="sf-screen sf-screen-result">'
        + '<p class="sf-kicker">' + esc(uiString("resultKicker")) + '</p>'
        + '<h2 class="sf-title">' + esc(uiString("resultTitle")) + '</h2>'
        + '<p class="sf-profile">' + esc(state.result.profile) + '</p>'
        + broadenedState
        + emptyState
        + '<ul class="sf-result-list">' + items + "</ul>"
        + '<div class="sf-actions sf-actions-result">'
        + sampleBtn
        + '<button type="button" class="sf-btn sf-btn-secondary" data-sf-back>' + esc(uiString("goBack")) + "</button>"
        + '<button type="button" class="sf-btn sf-btn-secondary" data-sf-restart>' + esc(uiString("startAgain")) + "</button>"
        + "</div></div>";
      wireEvents();
      return;
    }

    if (state.step === -1) {
      if (lastTrackedScreen !== "intro") {
        lastTrackedScreen = "intro";
        trackScentFinder("scent_finder_intro_view");
      }
      app.innerHTML = ''
        + '<div class="sf-screen sf-intro">'
        + '<p class="sf-kicker">Süskind</p>'
        + '<h2 class="sf-title">' + esc(uiString("introTitle")) + '</h2>'
        + '<p class="sf-profile">' + esc(uiString("introDescription")) + '</p>'
        + '<div class="sf-actions"><button class="sf-btn sf-btn-primary" data-sf-start>' + esc(uiString("begin")) + '</button></div>'
        + "</div>";
      wireEvents();
      return;
    }

    var current = STEPS[state.step];
    if (current) {
      var stepScreenKey = "step:" + current.key + ":" + state.step;
      if (lastTrackedScreen !== stepScreenKey) {
        lastTrackedScreen = stepScreenKey;
        trackScentFinder("scent_finder_step_view", Object.assign({}, currentAnswerSnapshot(), {
          sf_step_key: current.key
        }));
      }
    }
    var selected = state.answers[current.key] || [];
    var isMemory = current.key === "memory";
    var isNotes = current.key === "notes";
    var stepOptions = getStepOptions(current);
    var optionWrapClass = "sf-options";
    if (isMemory) optionWrapClass += " sf-options-grid";
    if (isNotes) optionWrapClass += " sf-options-notes";

    var optionsHtml = stepOptions.map(function (opt) {
      var isSelected = selected.indexOf(opt.id) !== -1;
      if (isNotes) {
        return ''
          + '<button type="button" class="sf-note-chip ' + (isSelected ? "is-selected" : "") + '" data-sf-option="' + esc(opt.id) + '">'
          + esc(opt.label)
          + "</button>";
      }

      var image = isMemory ? MEMORY_IMAGES[opt.id] : null;
      var details = isMemory ? MEMORY_DETAILS[opt.id] : null;

      return ''
        + '<button type="button" class="sf-option ' + (isSelected ? "is-selected" : "") + " " + (isMemory ? "sf-option-memory" : "") + '" data-sf-option="' + esc(opt.id) + '">'
        + (image ? '<img class="sf-memory-image" src="' + esc(image) + '" alt="">' : "")
        + '<span class="sf-option-label">' + esc(opt.label) + "</span>"
        + (opt.sublabel ? '<span class="sf-option-sub">' + esc(opt.sublabel) + "</span>" : "")
        + (details ? '<span class="sf-option-detail">' + esc(details) + "</span>" : "")
        + "</button>";
    }).join("");

    var metaHtml = "";
    if (isNotes) {
      var notesQuestion = uiString("notesQuestion") || current.question;
      var notesHint = uiString("notesHint") || current.hint || "";
      var notesCount = uiString("notesSelected")(selected.length, current.maxSelect);
      metaHtml = '<p class="sf-meta">' + esc(notesHint) + "</p>"
        + '<p class="sf-meta sf-meta-count">' + esc(notesCount) + "</p>";
      current = Object.assign({}, current, { question: notesQuestion });
    } else if (current.multi) {
      metaHtml = '<p class="sf-meta">Select at least ' + current.minSelect + ", up to " + current.maxSelect + "</p>";
    }

    var showContinue = current.multi || isNotes;

    app.innerHTML = ''
      + '<div class="sf-screen' + (isNotes ? " sf-screen-notes" : "") + '">'
      + '<div class="sf-progress"><span style="width:' + (((state.step + 1) / STEPS.length) * 100).toFixed(1) + '%"></span></div>'
      + '<h2 class="sf-title">' + esc(current.question) + "</h2>"
      + metaHtml
      + '<div class="' + optionWrapClass + '">' + optionsHtml + "</div>"
      + '<div class="sf-actions">'
      + '<button type="button" class="sf-btn sf-btn-secondary" data-sf-back>Go back</button>'
      + (showContinue ? '<button type="button" class="sf-btn sf-btn-primary" data-sf-continue ' + (canContinueStep(current, selected) ? "" : "disabled") + ">Continue</button>" : "")
      + "</div></div>";
    wireEvents();
  }

  function wireEvents() {
    var start = app.querySelector("[data-sf-start]");
    if (start) {
      start.addEventListener("click", function () {
        trackScentFinder("scent_finder_start");
        state.step = 0;
        render();
      });
    }

    var restart = app.querySelector("[data-sf-restart]");
    if (restart) {
      restart.addEventListener("click", function () {
        trackScentFinder("scent_finder_restart", currentAnswerSnapshot());
        state.step = -1;
        state.answers = {};
        state.result = null;
        render();
      });
    }

    var back = app.querySelector("[data-sf-back]");
    if (back) {
      back.addEventListener("click", function () {
        trackScentFinder("scent_finder_back", currentAnswerSnapshot());
        if (state.result) {
          state.result = null;
          state.step = STEPS.length - 1;
        } else {
          state.step = Math.max(-1, state.step - 1);
        }
        render();
      });
    }

    var continueBtn = app.querySelector("[data-sf-continue]");
    if (continueBtn) {
      continueBtn.addEventListener("click", function () {
        var current = STEPS[state.step];
        trackScentFinder("scent_finder_continue", Object.assign({}, currentAnswerSnapshot(), {
          sf_step_key: current ? current.key : null
        }));
        advance();
      });
    }

    var sampleBtn = app.querySelector(".sf-btn-samples");
    if (sampleBtn) {
      sampleBtn.addEventListener("click", function () {
        trackScentFinder("scent_finder_samples_click", Object.assign({}, currentAnswerSnapshot(), {
          sf_result_count: state.result && state.result.recs ? state.result.recs.length : 0
        }));
      });
    }

    app.querySelectorAll("[data-sf-option]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var id = btn.getAttribute("data-sf-option");
        selectOption(id);
      });
    });
  }

  function selectOption(id) {
    var current = STEPS[state.step];
    if (!current) return;
    var key = current.key;
    var prev = state.answers[key] || [];

    if (current.multi) {
      if (prev.indexOf(id) !== -1) {
        state.answers[key] = prev.filter(function (v) { return v !== id; });
      } else if (prev.length < current.maxSelect) {
        state.answers[key] = prev.concat(id);
      }
      trackScentFinder("scent_finder_option_select", Object.assign({}, currentAnswerSnapshot(), {
        sf_step_key: key,
        sf_option_id: id,
        sf_multi: true
      }));
      render();
      return;
    }

    if (key === "memory") {
      delete state.answers.notes;
    }

    state.answers[key] = [id];
    trackScentFinder("scent_finder_option_select", Object.assign({}, currentAnswerSnapshot(), {
      sf_step_key: key,
      sf_option_id: id,
      sf_multi: false
    }));
    setTimeout(function () { advance(); }, 120);
  }

  function advance() {
    var next = state.step + 1;
    if (next >= STEPS.length) {
      state.result = computeResult({
        occasion: (state.answers.occasion || ["daily"])[0],
        memory: (state.answers.memory || ["forest"])[0],
        notes: state.answers.notes || [],
        intensity: (state.answers.intensity || ["balanced"])[0]
      });
      trackScentFinder("scent_finder_result", Object.assign({}, currentAnswerSnapshot(), {
        sf_result_count: (state.result.recs || []).length,
        sf_fallback_used: !!state.result.fallbackUsed,
        sf_no_collection: !!state.result.noCollection,
        sf_result_names: (state.result.recs || []).map(function (p) { return p.name; }).join(",")
      }));
      render();
      return;
    }
    state.step = next;
    render();
  }

  function isFinderHash() {
    var hash = (window.location.hash || "").toLowerCase();
    return hash === "#finder" || hash === "#scent-finder";
  }

  function openFromHash() {
    if (isFinderHash()) openOverlay();
  }

  document.querySelectorAll("[data-open-scent-finder]").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      openOverlay();
    });
  });

  document.addEventListener("click", function (e) {
    var link = e.target && e.target.closest
      ? e.target.closest('a[href="#finder"], a[href="#scent-finder"]')
      : null;
    if (!link) return;
    e.preventDefault();
    openOverlay();
    var targetHash = (link.getAttribute("href") || "#finder").split("?")[0];
    if (window.location.hash !== targetHash) {
      if (history.replaceState) {
        history.replaceState(null, "", targetHash);
      } else {
        window.location.hash = targetHash;
      }
    }
  });

  window.addEventListener("hashchange", openFromHash);
  if (isFinderHash()) {
    setTimeout(openFromHash, 0);
  }

  overlay.querySelectorAll("[data-sf-close]").forEach(function (btn) {
    btn.addEventListener("click", closeOverlay);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && overlay.classList.contains("is-open")) closeOverlay();
  });
})();
